var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isOpen
    ? _c(
        "div",
        {
          staticClass: "dialog-mask",
          on: {
            click: function ($event) {
              if ($event.target !== $event.currentTarget) return null
              return _vm.onClickOutSide.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-container" }, [
            _c("div", { staticClass: "dialog-title" }, [
              _c("h3", { staticClass: "dialog-title-text" }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
              _c(
                "button",
                {
                  staticClass: "close-button",
                  on: { click: _vm.onClickOutSide },
                },
                [_vm._v("×")]
              ),
            ]),
            _c("div", { staticClass: "dialog-content" }, [
              _vm.fetchError
                ? _c("div", { staticClass: "fetch-error" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("historyManageDialog.fetchError")) +
                        " "
                    ),
                  ])
                : _c("div", { staticClass: "content" }, [
                    _c(
                      "div",
                      { staticClass: "main-content" },
                      [
                        _vm.requireUpgrade
                          ? _c(
                              "div",
                              { staticClass: "unsupported-plan-message" },
                              [
                                _c("premium-feature-introduce", {
                                  attrs: {
                                    title: _vm.$t(
                                      "historyManageDialog.premiumGuide.title"
                                    ),
                                    description: _vm.$t(
                                      "historyManageDialog.premiumGuide.description"
                                    ),
                                  },
                                }),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              { staticClass: "preview-content-inner" },
                              [
                                _vm.$slots.notification
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "history-item-notification",
                                      },
                                      [_vm._t("notification")],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._t("content", null, {
                                  historyItem: _vm.historyDetail,
                                }),
                              ],
                              2
                            ),
                        _c("transition", { attrs: { name: "fade" } }, [
                          _vm.historyDetailLoading
                            ? _c("div", { staticClass: "loading" })
                            : _vm._e(),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "side-content",
                        class: { "history-expanded": _vm.isHistoryExpanded },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "history-list" },
                          [
                            _c("div", { staticClass: "history-list-title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("historyManageDialog.versionHistory")
                                )
                              ),
                            ]),
                            _vm.isHistoryExpanded
                              ? _c(
                                  "div",
                                  { staticClass: "history-list-notice" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "historyManageDialog.historyLoadingNotice"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            !_vm.history
                              ? _c("div", [_c("loading-spinner")], 1)
                              : _vm.history.length === 0
                              ? _c(
                                  "div",
                                  { staticClass: "history-list-empty" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "historyManageDialog.versionHistoryEmpty"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._l(_vm.displayingHistoryList, function (h) {
                                  return _c(
                                    "div",
                                    {
                                      key: h.id,
                                      on: {
                                        click: function ($event) {
                                          h.restoreExpired
                                            ? _vm.showRequireUpgradeDialog()
                                            : _vm.fetchHistoryDetail(h.id)
                                        },
                                      },
                                    },
                                    [
                                      h.yearMessage
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "history-item-year-message",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(h.yearMessage) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      h.restoreExpiredMessage
                                        ? _c("div", {
                                            staticClass:
                                              "history-item-restore-expired-message",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                h.restoreExpiredMessage
                                              ),
                                            },
                                          })
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "history-item",
                                          attrs: {
                                            "data-active":
                                              _vm.historyItemId === h.id,
                                            "data-premium-required":
                                              h.restoreExpired,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "history-item-timestamp",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.isHistoryExpanded
                                                      ? h.message
                                                      : h.displayNumber
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                          ],
                          2
                        ),
                        _c("div", { staticClass: "side-content-footer" }, [
                          _c(
                            "div",
                            { staticClass: "restore-area" },
                            [
                              _c(
                                "button-default",
                                {
                                  staticClass: "restore-button",
                                  attrs: {
                                    disabled:
                                      _vm.requireUpgrade ||
                                      _vm.historyDetailLoading ||
                                      !_vm.historyDetail,
                                  },
                                  on: { click: _vm.openRestoreConfirmDialog },
                                },
                                [
                                  _vm.isHistoryExpanded
                                    ? [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "historyManageDialog.restoreButton"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    : _c("file-restore-outline-icon"),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "history-toggle-button",
                              attrs: {
                                type: "button",
                                "aria-label": String(
                                  _vm.isHistoryExpanded
                                    ? _vm.$t(
                                        "historyManageDialog.collapseHistory"
                                      )
                                    : _vm.$t(
                                        "historyManageDialog.expandHistory"
                                      )
                                ),
                              },
                              on: { click: _vm.toggleHistoryPanel },
                            },
                            [
                              _c("img", {
                                class: { expanded: _vm.isHistoryExpanded },
                                attrs: {
                                  src: require("@/assets/img/icon/expand_less.svg"),
                                  alt: "",
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
            ]),
          ]),
          _vm.isOpenRestoreConfirmDialog
            ? _c("cupertino-alert-dialog", {
                attrs: {
                  title: _vm.$t("historyManageDialog.confirmDialog.title"),
                  close: _vm.closeRestoreConfirmDialog,
                  width: "400",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "content",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "confirm-message" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "historyManageDialog.confirmDialog.content"
                                )
                              )
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "actions",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "confirm-actions" }, [
                            _c(
                              "button",
                              {
                                staticClass: "confirm-button",
                                on: { click: _vm.onConfirmRestore },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "historyManageDialog.confirmDialog.restore"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "cancel-button",
                                on: { click: _vm.closeRestoreConfirmDialog },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "historyManageDialog.confirmDialog.cancel"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3251717486
                ),
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }